import { apiSlice } from "features/api/apiSlice";

const getDoctorFees = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getDoctorFees: build.mutation({
      query: ({ id, type }) => ({
        url: "/appointments/breakdown",
        method: "POST",
        body: { practitionerId: id, appointmentType: type },
      }),
      transformResponse: (res) => res.d,
    }),
  }),
});

export const { useGetDoctorFeesMutation } = getDoctorFees;
